import { useCallback, useEffect, useRef } from "react";
import { useDispatch } from "react-redux";
import { setLocation } from "../features/detectSlice";

export default function useLocation() {
    const dispatch = useDispatch();
    const watchIdRef = useRef(null);

    const startWatching = useCallback(() => {
        // Clear any existing watcher first
        if (watchIdRef.current !== null) {
            navigator.geolocation.clearWatch(watchIdRef.current);
        }

        watchIdRef.current = navigator.geolocation.watchPosition(
            (position) => {
                const { latitude, longitude } = position.coords;
                dispatch(setLocation(latitude, longitude));
            },
            (err) => {
                console.error("Geolocation error:", err);
                dispatch(setLocation(-1, -1));
            },
            {
                enableHighAccuracy: true,
                maximumAge: 0,     // Never use cached position
                timeout: 10000,    // 10 second timeout
            }
        );
    }, [dispatch]);

    const stopWatching = useCallback(() => {
        if (watchIdRef.current !== null) {
            navigator.geolocation.clearWatch(watchIdRef.current);
            watchIdRef.current = null;
        }
    }, []);

    // Cleanup on unmount
    useEffect(() => {
        return () => {
            if (watchIdRef.current !== null) {
                navigator.geolocation.clearWatch(watchIdRef.current);
            }
        };
    }, []);

    return { startWatching, stopWatching };
}